export const BASE_URL =
    process.env.BASE_URL ||
    "https://phase3dev.worldofsquiggles.com/wp-json/squiggles/v1";
